/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCount16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={18}
      fill='none'
      viewBox='0 0 18 18'
      {...props}
    >
      <path fill='#DEE0E2' d='M0 9a9 9 0 1118 0A9 9 0 010 9z' />
      <path
        fill='#484C51'
        d='M5.598 13H6.95V5.355H5.84c-.253.814-.836 1.221-1.65 1.232h-.231v1.221h.352c.473 0 1.023-.154 1.287-.462V13zm2.916 0h5.368v-1.133h-3.53a13.013 13.013 0 001.891-1.408c1.067-.968 1.562-1.87 1.562-2.926 0-1.496-.957-2.343-2.574-2.343-1.65 0-2.673.891-2.673 2.288 0 .187.022.396.077.605L10 8.215a3.138 3.138 0 01-.077-.671c0-.759.462-1.243 1.243-1.243.77 0 1.2.462 1.2 1.298 0 .836-.309 1.452-1.178 2.266a19.951 19.951 0 01-2.673 2.101V13z'
      />
    </svg>
  );
}

export default SvgCount16;
